export default "/assets/images/mini-nav-menu.6ea273470e22803a.jpg";